import env from './env';

const appKeys = {
  production: '1ed36fa9136b6ae7b14c',
  staging: '073f5028da78dbeb4de1',
  development: '0c8387cc06639c404e89',
};

const appKey = appKeys[env] || appKeys.development;

export const PUSHER_APP_KEY = appKey;
export const PUSHER_APP_CLUSTER = 'eu';
export const PUSHER_LOG = env === 'development' || env === 'staging';
